import React from "react";

interface PDFPreviewModalProps {
  open: boolean;
  url: string;
  name: string;
  onClose: () => void;
}

const PDFPreviewModal: React.FC<PDFPreviewModalProps> = ({
  open,
  url,
  name,
  onClose,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-6">
      <div className="bg-white w-full max-w-6xl h-[85vh] rounded-lg shadow-lg relative overflow-hidden flex flex-col">
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-lg font-semibold truncate">
            {decodeURIComponent(name)}
          </h2>
          <button
            className="text-sm text-gray-500 hover:text-black"
            onClick={onClose}
          >
            ✕ Close
          </button>
        </div>

        <iframe src={url} title={name} className="w-full flex-1 border-none" />
      </div>
    </div>
  );
};

export default PDFPreviewModal;
